<div #cardlist class="card" [ngClass]="['arc-' + ratio, section]" >
  <div
    #imagcontainer
    (focus)="addScroll()"
    (focusout)="removeScroll()"
    (mouseover)="focusCard()"
    class="image-parent focusable-element"
    [attr.aria-labelledby]="'cardTitle' + item.id"
    tabindex="0"
  >
  <span id="cardTitle{{item.id}}" style="display: none;">{{'.' | ttsConcat: item.title : item.shortDescription}}</span>
    <app-tag [isBlocked]="item.isPremium" position="top-right"></app-tag>
    <app-tag [text]="item.tags && item.tags.length > 0 ? item.tags[0] : undefined"></app-tag>
    <app-tag *ngIf="item.isLive" [isLive]="true" position="bottom-right" color="dark"></app-tag>
    <img
      loading="lazy"
      class="image-parent__min-size image-parent__{{ ratio }} skeleton"
      [src]="img"
      alt=""
      onerror="this.classList.add('no-image'); this.classList.remove('skeleton');"
    />
  </div>
  <div *ngIf="showTitle" class="card__title">
    <h1 class="card__title__text">{{ title }}</h1>
  </div>
</div>
